import styled from "styled-components";

export const Embla = styled.div`
  --slide-height: 19rem;
  --slide-spacing: 1rem;
  --slide-size: 100%;
  --slide-spacing-sm: 1.6rem;
  --slide-size-sm: 50%;
  --slide-spacing-lg: 2rem;
  --slide-size-lg: calc(100% / 3);
`;

export const EmblaViewport = styled.div`
  overflow: hidden;
`;

export const EmblaContainer = styled.div`
  gap: 2rem;
  backface-visibility: hidden;
  display: flex;
  touch-action: pan-y pinch-zoom;
  margin-left: calc(var(--slide-spacing-sm) * 0.8);
  margin-right: calc(var(--slide-spacing-sm) * 0.8);

  @media (min-width: 600px) {
    margin-left: calc(var(--slide-spacing-lg) * 2);
    margin-right: calc(var(--slide-spacing-lg) * 0.5);
  }

  @media (min-width: 1400px) {
    margin-left: calc(var(--slide-spacing-lg) * 3.8);
    margin-right: calc(var(--slide-spacing-lg) * 0.5);
  }
`;

export const EmblaSlide = styled.div`
  background-color: #f5f5f5;
  cursor: pointer;
  max-width: 280px;
  height: 340px;
  border-radius: 0.6rem;
  box-shadow: 0 0 0.4rem rgba(var(--text-high-contrast-rgb-value), 0.1);
  flex: 0 0 var(--slide-size);

  @media (min-width: 750px) {
    flex: 0 0 var(--slide-size-sm);
  }

  @media (min-width: 1400px) {
    flex: 0 0 var(--slide-size-lg);
  }
`;

export const ImageCarousel = styled.img.attrs({
  loading: "lazy",
  decoding: "async", // dica extra
})`
  width: 100%;
  height: 63%;
  background-color: #f0f0f0;
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
  object-fit: cover;
`;

export const EmblaSlideText = styled.div`
  position: absolute;
  padding: 10px;
  border-bottom-left-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
  box-sizing: border-box;
  max-width: 280px;
  width: 100%;
`;

export const H2Carousel = styled.h2`
  font-size: 1.4rem;
  font-weight: bold;
  color: #202020;
  padding: 0;
  margin: 0;
  margin-bottom: 0.5rem;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
`;

export const PCarousel = styled.p`
  font-size: 1.1rem;
  font-weight: bold;
  color: #89898a;
  padding: 0;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
`;
